import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

import { RejectFiles } from "../../api/preworkDetailApi/preworkDetailApi";
import { useSnackbar } from "../Common/SnackbarContext";
import LocalStorageUtil from "../../utils/localStorage";

interface RejectFileProps {
  isOpen: boolean;
  onClose: (isCancelClick: boolean, tabValue?: number) => void;
  title: string;
  selectedData: any;
  tabValue?: number;
}

const RejectFile: React.FC<RejectFileProps> = ({
  isOpen,
  onClose,
  title,
  selectedData,
  tabValue,
}) => {
  const [remark, setRemark] = useState<string>("");
  const [remarkValidationMessage, setRemarkValidationMessage] = useState<
    string | null
  >(null);
  const { showSnackbar } = useSnackbar();
  const [loading, setLoading] = useState<boolean>(false);

  const handleYesClick = async () => {
    debugger;
    try {
      setLoading(true);
      if (remark === "") {
        setRemarkValidationMessage("Please enter the remark");
      } else {
        let preworkRejectFile: any[] = [];
        selectedData.forEach((item: any) => {
          const rejectFile = {
            checkBoxDocumentId: item.CheckBoxDocumentId,
            checkBoxDocumentStreamId: item.CheckBoxDocumentStreamId,
            Remarks: remark,
            Accntid: Number(LocalStorageUtil.getItem("accountId")),
            Userid: Number(LocalStorageUtil.getItem("userId")),
            contextName: LocalStorageUtil.getItem("contextName") ?? "",
          };
          preworkRejectFile.push(rejectFile);
        });
        const response = await RejectFiles(preworkRejectFile);
        if (response) {
          showSnackbar("File Rejected Successfully");
          setRemarkValidationMessage(null);
          onClose(false);
          onClose(false, tabValue);
        } else {
          console.log("Error in reject file");
        }
      }
    } catch (error) {
      console.log("Error in rejecting file ", error);
    } finally {
      setLoading(false);
    }
  };

  //Close the dialog box
  const handleNoClick = () => {
    onClose(true);
  };

  const handleRemarkChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const value = event.target.value;
      setRemark(value);
    } catch (error) {
      console.error("Error in remark change", error);
      throw error;
    } finally {
      setRemarkValidationMessage(null);
    }
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleNoClick}
        maxWidth="sm"
        PaperProps={{
          style: {
            height: "auto",
            width: "20%",
          },
        }}
      >
        <DialogTitle
           style={{
            backgroundColor: "var(--primary-color)",
                    color: "var(--aggrid-text-color)",
                    fontSize: "16px", 
                    fontWeight: 500, 
                    padding: "12px 16px", 
                    display: "flex",
                    alignItems: "center",
          }}
        >
          <div
            className="col-sm-12"
            style={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <div
              className="col-sm-11"
              style={{
                display: "flex",
                alignItems: "left",
                gap: "10px",
                color: "var(--aggrid-text-color)",
              }}
            >
              {title}
            </div>
            <div
              className="col-sm-1"
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "right",
              }}
            >
              {" "}
              <Tooltip title="Close">
                <IconButton
                  onClick={handleNoClick}
                  style={{
                    cursor: "pointer",
                    alignItems: "flex-end",
                    color: "var(--aggrid-text-color)",
                    width: "20px",
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "60%",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div className="row">
              <div
                className="col-sm-12"
                style={{
                  marginTop: "1.125em",
                  fontSize: "0.7rem",
                  fontWeight: "bold",
                }}
              >
                Are you sure you want to Reject?
              </div>
              <div
                className="col-sm-12"
                style={{
                  marginTop: "1.25em",
                  fontSize: "0.7rem",
                  fontWeight: "bold",
                }}
              >
                Remark *
              </div>
              <div className="col-sm-12" style={{ marginTop: "8px" }}>
                <TextField
                  multiline
                  minRows={3}
                  aria-label="maxWidth"
                  maxRows={3}
                  style={{
                    width: "100%",
                    height: "100%",
                    overflow: "auto",
                  }}
                  placeholder="Enter Remark text here"
                  value={remark}
                  error={!!remarkValidationMessage}
                  helperText={remarkValidationMessage}
                  onChange={handleRemarkChange}
                  InputProps={{
                    sx: {
                      backgroundColor: "var(--aggrid-background-color)",
                      fontFamily: "monospace",
                      borderRadius: "0.3125em",
                      border: "1px solid #A0C4FF",
                      height: "100%",
                      "& textarea": {
                        height: "100% !important",
                        resize: "vertical",
                      },
                      "&:focus-within": {
                        border: "2px solid #6699CC",
                      },
                    },
                  }}
                  sx={{
                    height: "100%",
                  }}
                />
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleYesClick}
            style={{ fontSize: "14px", height: "2.1em", padding: "4px 6px",border: "1px solid #144979", }}
          >
            Yes
          </Button>
          <Button
            style={{ fontSize: "14px", height: "2.1em", padding: "4px 6px",border: "1px solid #144979", }}
            onClick={handleNoClick}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RejectFile;
